export default "__VITE_ASSET__CSwrjNCQ__"